<template>
<div class="ls-metric-banner">
  <div class="metrics-banner-item" v-for="serie in series">
    <h5 v-if="series.length > 1">{{ serie.name }}</h5>
    <h5 v-else></h5>
    <div class="metric-value">{{ serie.value || '-' }}</div>
  </div>
</div>
</template>


<script>
export default {
  props: {
    series: {
      type: Array,
      required: true,
    },
  },
  computed: {
  },
  data: function () {
    // var defaultPageSize = (this.tableData.length % 10) >= 3 ? 10 : 10 + (this.tableData.length % 10);

    return {

    };
  },
  watch: {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
@import "./static/css/_variables.scss";
.ls-metric-banner {
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    .metrics-banner-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 1.8em;
        font-weight: 600;
        margin: 2px;
        background-color: #fff;
        color: $ls-highlight-color;
        text-align: center;
        flex: 1;

        h5 {
            color: $ls-base-color;
            font-weight: 700;
            font-size: .6em;
        }

        .metric-value {
            padding-bottom: 15px;
        }

      & + .metrics-banner-item {
        border-left: 1px solid #ffecec;
      }
    }
}
</style>



// WEBPACK FOOTER //
// LsMetricBanner.vue?a8b51482